import Organization from 'services/organization';
import { useOrganizationStore, useUserStore } from 'store/modules';

export default function (to, from, next) {
    const userStore = useUserStore();
    const organizationStore = useOrganizationStore();

    if (
        !Organization.isAgencyWithoutSubscription ||
        to.name === 'force-password-change' ||
        to.name === 'auth.reset' ||
        to.name === 'register.multiorg'
    ) {
        next();
        return;
    }

    const user = userStore.user;
    const organization = organizationStore.organization;
    const isOwner = user?.id === organization?.user_id;

    if (!isOwner && to.name === 'suspended') {
        next();
        return;
    }

    if (
        isOwner &&
        !to.matched.some((record) => record.meta.agency === true) &&
        to.name !== 'clients'
    ) {
        next('/clients');
        return;
    }

    if (
        Organization.isAgencyWithoutSubscription &&
        to.name !== 'clients' &&
        !to.path?.startsWith('/settings') &&
        !to.path?.includes('settings/upgrade')
    ) {
        next('/clients');
        return;
    }

    next();
}
